import { Role } from "@/acl/roles";
import { PRODUCTS_DETAILS } from "@/assets/constants/products/ais";

export default {
  orgName: "AIS",
  logoPath: require("@/assets/images/logo/ais.svg"),
  navBarLogoStyle: "width: 100%;",
  allowedLoginMethods: ["Google"],
  products: PRODUCTS_DETAILS,
  possibleRoles: [Role.superAdmin, Role.admin],
  admin: true,
  availableLanguages: ["en", "fr"],
};
